<div *ngIf="this.nextConfig['layout'] === 'vertical'"
    id="nav-ps-next"
    class="nav-scroll"
    (clickOutside)="navMob()">
    <div class="navbar-content">
        <ul class="nav pcoded-inner-navbar" (clickOutside)="fireOutClick()">
            <ng-container *ngFor="let item of navigation">
                <app-nav-group *ngIf="item.type=='group'" [item]="item"></app-nav-group>

                <app-nav-collapse *ngIf="item.type=='collapse'" [item]="item"></app-nav-collapse>

                <app-nav-item *ngIf="item.type=='item'" [item]="item"></app-nav-item>
            </ng-container>
        </ul>

    </div>
</div>

<div *ngIf="this.nextConfig['layout'] === 'horizontal'"
    #navbarWrapper
    id="layout-sidenav"
    class="navbar-content sidenav-horizontal">
    <a href="javascript:"
        class="sidenav-horizontal-prev"
        [ngClass]="prevDisabled"
        (click)="scrollMinus()">
    </a>

    <div  class="sidenav-horizontal-wrapper"><!-- add 14-4 viral -->
        <ul #navbarContent id="side-nav-horizontal"
            class="nav pcoded-inner-navbar sidenav-inner"
            (clickOutside)="fireLeave()"
            (mouseleave)="fireLeave()">
            <ng-container *ngFor="let item of navigation">
                <app-nav-group *ngIf="item.type=='group'" [item]="item"></app-nav-group>

                <app-nav-collapse *ngIf="item.type=='collapse'" [item]="item"></app-nav-collapse>

                <app-nav-item *ngIf="item.type=='item'" [item]="item"></app-nav-item>
            </ng-container>
        </ul>
    </div>

    <a href="javascript:"
        class="sidenav-horizontal-next"
        [ngClass]="nextDisabled"
        (click)="scrollPlus()">
    </a>
</div>
